<template>
	<div class="adminbbsshow">
		<div class="top_fixed">
			<div v-if="keylist.length>0">
				<div class="bbs_keyword_title">当前帖子命中关键词</div>
				<div class="bbs_keyword">
					<span v-for="(item, index) in info.keyword_info" :key="'keylist_' + item.id"><span v-if="index>0">、</span>{{item.title}} ({{item.num}}次)</span>
				</div>
			</div>
			<!-- <div class="search_box">
				<div class="search_input" @click="goText()">关键词:xxxxx</div>
				<div class="now_keyword">当前词</div>
				<div class="next_keyword">下一词</div>
			</div> -->
			<div class="bbs_keyword_title">帖子内容</div>
		</div>
		<div class="show">
			<h3 v-html="info.title"></h3>
			<div class="media">
				<!-- <img :src="info.user.headimg_url" /> -->
				<span style="color: #333333;">{{ info.author }}</span>
				<span style="margin-left: 15px;font-size: 10px;">更新时间:{{ post_time }}</span>
				<span style="margin-left: 10px;font-size: 10px;">阅读:{{ info.read_num }}</span>
				<span style="margin-left: 10px;font-size: 10px;">评论:{{ info.comment_num }}</span>
			</div>
			<div v-html="info.content" class="content"></div>
			<div v-for="(img, index) in info.image" :key="'img_' + index">
				<img class="img" v-lazy="img" @click="showImg(index,1)" />
			</div>
			<div class="comment_box" v-if="comments.length>0">
				<div class="comment_list" v-for="item in comments" :key="'commen_' + item.id">
					<div style="color: #666666;margin-bottom: 10px;">
						<span class="comment_user" style="color: #666666;">{{item.car_user_name}}：</span><span class="comment_text" style="color: #666666;" v-html="item.content"></span>
					</div>
						<!-- <span class="comment_user">{{item.car_user_name}} <span>回复</span>：</span><span class="comment_text" v-html="item.content"></span>
						<div class="comment_time">{{item.post_time}}</div> -->
				</div>

			</div>
		</div>
		<div class="bottom_fixed">
			<!-- <div class="bbs_bottom_fixed_keyword_title">帖子维护</div> -->
			<div class="bbs_bottom_box">
				<div class="bbs_bottom_box_top">
					<div class="bbs_bottom_box_listl">
						<div class="bbs_bottom_top_title">作者</div>
						<div class="bbs_bottom_top_name">{{info.author}}</div>
					</div>
					<div class="bbs_bottom_box_list">
						<div class="bbs_bottom_top_title">作者主贴数</div>
						<div class="bbs_bottom_top_name">{{info.bbs_num}}篇</div>
					</div>
					<div class="bbs_bottom_top_check_list text-r">
						<div class="bbs_bottom_top_check" @click="checkUserbbs()">查看 ></div>
					</div>
				</div>
				<!-- <div class="bbs_bottom_btn_box">
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.member_avatar">
						<div style="color: #c3c3c3;">用户画像</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.reply">
						<div style="color: #c3c3c3;">回复主贴</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.member_tips">
						<div style="color: #c3c3c3;">标记作者</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.member_focus">
						<div style="color: #c3c3c3;">关注用户</div>
					</div>
					<div class="bbs_bottom_btn" @click="show = true">
						<img class="bbs_bottom_img" :src="img.bbs_sign">
						<div style="color: #c3c3c3;">标记帖子</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.bbs_collect">
						<div style="color: #c3c3c3;">收藏帖子</div>
					</div>
				</div> -->
				<!-- <div class="bbs_bottom_btn_box">
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.bbs_tips">
						<div style="color: #c3c3c3;">帖子标签</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.bbs_info">
						<div style="color: #c3c3c3;">论坛维护</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.bbs_sign">
						<div style="color: #c3c3c3;">标记帖子</div>
					</div>
					<div class="bbs_bottom_btn">
						<img class="bbs_bottom_img" :src="img.bbs_collect">
						<div style="color: #c3c3c3;">收藏帖子</div>
					</div>
				</div> -->
			</div>
		</div>
		<van-overlay :show="show">
			<div class="overlay_box">
				<img class="overlay_close" :src="img.close" @click="show = false">
				<div class="text-c f-18">标记帖子</div>
				<van-tabs v-if="show" v-model="active">
					<van-tab title="标记内容">
						<div class="option_box" v-for="(item,index) in checklist" :key="'list_'+item.id" @click="checkBox(index)">
							<img class="check_img" v-if="item.checked" :src="img.check">
							<div class="check_circle" v-else></div>
							<div class="check_name">{{item.title}}</div>
						</div>
					</van-tab>
					<van-tab title="负面标记">
						<div class="option_box" v-for="(item,index) in checklist" :key="'list_'+item.id" @click="checkBox(index)">
							<img class="check_img" v-if="item.checked" :src="img.check">
							<div class="check_circle" v-else></div>
							<div class="check_name">{{item.title}}</div>
						</div>
					</van-tab>
					<van-tab title="功能3">
						<div class="option_box" v-for="(item,index) in checklist" :key="'list_'+item.id" @click="checkBox(index)">
							<img class="check_img" v-if="item.checked" :src="img.check">
							<div class="check_circle" v-else></div>
							<div class="check_name">{{item.title}}</div>
						</div>
					</van-tab>
					<van-tab title="功能4">
						<div class="option_box" v-for="(item,index) in checklist" :key="'list_'+item.id" @click="checkBox(index)">
							<img class="check_img" v-if="item.checked" :src="img.check">
							<div class="check_circle" v-else></div>
							<div class="check_name">{{item.title}}</div>
						</div>
					</van-tab>
				</van-tabs>
				<div class="check_ok" @click="checkOk()">标记完成</div>
			</div>

		</van-overlay>
	</div>
</template>
<script>
	import admin from '../../api/admin';
	import member from '../../api/member/memberinfo';
	import { mapState } from 'vuex';
	import {Row, Col, Tag,NavBar,Grid, GridItem,List,Field,Button,Overlay,ActionSheet,Divider,Tab, Tabs,Checkbox, CheckboxGroup,Dialog  } from "vant";
	export default {
		data () {
			return {
				show:false,
				bbs_id:'',
				rid:'',
				info: '',
				paramc:{
					page: 1,
				},
				loading: false,
				finished: false,
				comments: [],
				keylist:[],
				post_time:'',
				active: 0,
				checklist:[{
					id:1,
					title:'优质内容',
					checked:false,
				},{
					id:2,
					title:'主回复内容',
					checked:false,
				},{
					id:3,
					title:'次回复内容',
					checked:false,
				},{
					id:4,
					title:'游记类型',
					checked:false,
				},{
					id:5,
					title:'作业类型',
					checked:false,
				},{
					id:6,
					title:'问答类型',
					checked:false,
				},{
					id:7,
					title:'XXX类型',
					checked:false,
				},{
					id:8,
					title:'XXX类型',
					checked:false,
				},{
					id:9,
					title:'XXX类型',
					checked:false,
				}],
				img: {
					member_avatar: require('../../assets/img/admin/member_avatar.png'),
					reply: require('../../assets/img/admin/reply.png'),
					member_tips: require('../../assets/img/admin/member_tips.png'),
					member_focus: require('../../assets/img/admin/member_focus.png'),
					bbs_tips: require('../../assets/img/admin/bbs_tips.png'),
					bbs_info: require('../../assets/img/admin/bbs_info.png'),
					bbs_sign: require('../../assets/img/admin/bbs_sign.png'),
					bbs_collect: require('../../assets/img/admin/bbs_collect.png'),
					close: require('../../assets/img/admin/close.png'),
					check: require('../../assets/img/admin/check.png'),
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user,
				source: state => state.param.source
			})
		},
		watch: {
			'$route'() {
				if(this.$route.query.id != this.bbs_id) {
					this.bbs_id = this.$route.query.id
					this.getInfo()
					this.getCommentList()
				}
			}
		},
		created () {
			if(this.$route.query.token){
				this.token = this.$route.query.token
				this.$store.dispatch('param/setToken', this.$route.query.token)
			}	
			if(localStorage.getItem('bbsid')){
				this.bbs_id = localStorage.getItem('bbsid')
				this.getInfo()
				this.getCommentList()
				localStorage.removeItem('bbsid')
			}else if(this.$route.query.id){
				this.bbs_id = this.$route.query.id
				this.getInfo()
				this.getCommentList()
			}
		},
		methods: {
			getInfo () {
				var params={
					bbs_id:this.bbs_id
				}
				admin.getShow(params).then(res => {
					if(res.data.state == 1) {
						this.info = res.data.data
						this.keylist=res.data.data.keyword_info
						var time=res.data.data.post_time
						this.post_time=time.substring(0,10)
					}
				})
			},
			getCommentList(){
				this.paramc.bbs_id=this.bbs_id
				admin.getCommentList(this.paramc).then(res => {
					var newlist = res.data.data
					
					this.comments.push.apply(this.comments, newlist)
					this.paramc.page += 1
					this.loading = false
					if(res.data.data.length == 0) {
						this.finished = true
					}
				})
			},
			checkUserbbs(){
				localStorage.setItem('moreuserid', this.info.user_id)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=usermorebbs'})
			},
			checkBox(num){
				var checklist=this.checklist
				if(checklist[num].checked){
					checklist[num].checked=false
					this.checklist=checklist
				}else{
					checklist[num].checked=true
					this.checklist=checklist
				}
				
			},
			checkOk(){
				var checklist=this.checklist 
				if(this.checklist.findIndex(target=>target.checked)==-1){
					Dialog.alert({
						message: '请选择一个帖子标记',
						confirmButtonColor:'#0091FF',
					}).then(() => {
					});
					
				}else {
					Dialog.confirm({
						message: '确定已选择的标记类型吗？',
						confirmButtonColor:'#0091FF',
						cancelButtonColor:'#0091FF'
					})
					.then(() => {
						this.show=false
					})
					.catch(() => {
					});
				}
				
			},
			onLoad() {
				setTimeout(() => {
					this.getCommentList()
				}, 500);
			},
		},

		components: {
			[Row.name]: Row,
			[Col.name]: Col,
			[Tag.name]: Tag,
			[NavBar.name]:NavBar,
			[Grid.name]: Grid,
			[GridItem.name]: GridItem,
			[List.name]:List,
			[Field.name]:Field,
			[Button.name]:Button,
			[Overlay.name]:Overlay,
			[ActionSheet.name]:ActionSheet,
			[Divider.name]:Divider,
			[Tab.name]:Tab,
			[Tabs.name]:Tabs,
			[Checkbox.name]:Checkbox,
			[CheckboxGroup.name]:CheckboxGroup,
			[Dialog.name]:Dialog 
		}
	};
</script>

<style lang="scss">
.adminbbsshow {
	padding: 15px;
	background-color: #F8F8F8;
	.top_fixed{
		// position: fixed;
		// top: 0;
		// right: 0px;
		// left: 0px;
		// background-color:#fff;
		.bbs_keyword_title{
			padding:15px 0;
			font-size: 14px;
			color:#666666;
			border-bottom:1px solid #eeeeee;
		}
		.bbs_keyword{
			font-size: 12px;
			color: red;
			margin-right: 5px;
			padding:10px 0;
			font-weight: 500;
		}
		.search_box{
			padding:5px 10px 5px 10px;
			display: flex;
			border:1px solid #BBBBBB;
			border-radius:4px;
			align-items:center;
			margin-top: 5px;
			.search_input{
				font-size: 12px;
				color: #999999;
				flex: 1;
				border:0;
			}
			.now_keyword{
				width: 70px;
				text-align: center;
				color: #fff;
				font-size: 12px;
				padding:5px 0;
				background-color:#BBBBBB;
				border-radius:4px;
			}
			.next_keyword{
				width: 70px;
				text-align: center;
				color: #fff;
				font-size: 12px;
				padding:5px 0;
				background-color:#333333;
				border-radius:4px;
				margin-left: 5px;
			}
		}
	}
	.bottom_fixed{
		position: fixed;
		bottom: 0;
		right: 0px;
		left: 0px;
		background-color:#fff;
		padding:15px 20px;
		border-top-right-radius:8px;
		border-top-left-radius:8px;
		padding-bottom: 20px;
		.bbs_bottom_fixed_keyword_title{
			padding:30px 0 15px 0;
			font-size: 14px;
			color:#666666;
			border-bottom:1px solid #eeeeee;
			border-top: 1px solid #eeeeee;
		}
		.bbs_bottom_box{
			// border:1px solid #BBBBBB;
			// border-radius:4px;
			// padding:15px;
			.bbs_bottom_box_top{
				display: flex;
				color: #666666;
				align-items:center;
				padding: 4px 15px;
				background-color:#f3f3f3;
				border-radius: 4px;
				.bbs_bottom_box_listl{
					width: 45%;
				}
				.bbs_bottom_box_list{
					width: 40%;
				}
				.bbs_bottom_top_title{
					font-size: 8px;
				}
				.bbs_bottom_top_name{
					font-size: 13px;
				}
				.bbs_bottom_top_check_list{
					width: 15%;
				}
				.bbs_bottom_top_check{
					font-size: 10px;
					// text-decoration:underline;
				}
			}
			.bbs_bottom_btn_box{
				display: flex;
				margin-top: 15px;
				.bbs_bottom_btn{
					width: 25%;
					margin: 0 5px;
					font-size: 12px;
					text-align: center;
					.bbs_bottom_img{
						width: 49px;
						height: 48px;
						
					}
					img{
						-webkit-filter: grayscale(100%);   
						-moz-filter: grayscale(100%);  
						-ms-filter: grayscale(100%);   
						-o-filter: grayscale(100%);     
						filter: grayscale(100%); 	     
						filter: gray;
					}
					.bbs_bottom_border_btn{
						color: #333333;
						font-size: 12px;
						border:1px solid #333333;
						border-radius:4px;
						text-align: center;
						padding:5px;
					}
				}
			}
		}
	}
	
	// .van-nav-bar__left {
	// 	left: 10px;
	// }
	.show {
		
		font-size: 14px;
		color: #3A3A3A;
		margin-bottom: 80px;
		margin-top: 15px;
		h3 {
			font-size: 17px;
			margin: 0;
		}
		.img {
			width: 100%;
			display: block;
			margin-top: 10px;
		}
		.media {
			color: #9A9A9A;
			font-size: 12px;
			margin: 20px 0;

			img {
				width: 30px;
				border-radius: 15px;
				vertical-align: middle;
			}
		}
		.content {
			font-size: 14px !important;

			img {
				height: 120px !important;
				width: 180px !important;
			}
			iframe{
				max-width: 100%;
			}
			video{
				max-width: 100%;
			}
		}
		.quoteparagraph-list-wrap{
			display: none;
		}
		.content iframe{
			width: 100%;
			height: 200px;
		}
		.content video{
			width: 100%;
			height: 200px;
		}
		.parise {
			text-align: center;
			margin: 30px 0 50px 0;

			a {
				color: #3A3A3A;
				font-size: 11px;
				display: inline-block;
				width: 110px;
				height: 35px;
				border: 1px solid #9A9A9A;
				line-height: 35px;
				border-radius: 17px;
				margin: 0 7px;
				box-sizing: border-box;

				img {
					width: 15px;
					height: 14px;
					vertical-align: middle;
					margin-right: 7px;
				}
			}
		}
		.comment_box{
			margin-top: 20px;
			border-top:1px solid #DDDDDD;
			padding:15px 0;
			.comment_list{
				padding:8px 0;
				font-size: 13px;
				.comment_user{
					font-weight: 600;
					color: #000000;
				}
				.comment_text{
					font-size: 12px;
					color: #000000;
				}
				.comment_time{
					font-size: 10px;
					color: #999999;
					margin-top: 8px;
				}
			}
		}
	}
	.overlay_box{
		color: #ffffff;
		background-color:transparent;
		.overlay_close{
			width: 24px;
			height: 24px;
			margin: 20px 15px;
		}
		.van-tabs{
			padding:15px;
		}
		.van-tabs__wrap{
			border-bottom:1px solid #fff;
		}
		.van-tabs__nav--line{
			padding:0 1px;
			background-color:transparent;
		}
		.van-tab{
			color: #fff;
		}
		.van-tabs__line{
			width: 56px;
			bottom:0;
			background-color:#fff;
		}
		.van-tab__pane{
			padding:0 0 0 20px;
			
		}
		.option_box{
			width: 33.333%;
			float: left;
			color: #ffffff;
			font-size: 12px;
			display: flex;
			align-item:center;
			margin: 30px 0 0 0;
			.check_img{
				width: 14px;
				height: 14px;
			}
			.check_circle{
				width: 12px;
				height: 12px;
				border:1px solid #ffffff;
				border-radius:50px;
			}
			.check_name{
				margin-left: 10px;
			}
		}
		.check_ok{
			position: fixed;
			margin: 0 auto;
			right: 0;
			left: 0;
			width: 110px;
			text-align: center;
			bottom: 20%;
			font-size: 14px;
			border-radius: 30px;
			padding: 5px 0;
			color: #fff;
			background-color:#0091FF;
		}
	}
}
</style>
